export const FREE = 'free';



// WEBPACK FOOTER //
// ./src/constants/consumerTypes.js